module.exports = __webpack_public_path__ + "img/product-placeholder-88.3b91ac4.png";